import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

function HowItWorks() {
  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 64px - 120px)',
        backgroundColor: '#F5F9FF',
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '2rem', md: '2.5rem' },
            fontWeight: 700,
            color: '#1A237E',
            mb: 3,
          }}
        >
          Så här fungerar det
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 5, lineHeight: 1.7 }}>
          Loggboken hjälper dig att dokumentera dina båtäventyr och underhåll på ett säkert och ordnat sätt. Här är en genomgång av hur tjänsten fungerar.
        </Typography>

        {/* Steg 1: Konto */}
        <Typography
          variant="h2"
          component="h2"
          sx={{
            fontSize: { xs: '1.25rem', md: '1.5rem' },
            fontWeight: 600,
            color: '#1A237E',
            mt: 5,
            mb: 1,
          }}
        >
          1. Skapa konto
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2, lineHeight: 1.7 }}>
          Du skapar ett konto med användarnamn, e-postadress och lösenord. Efter registrering skickas ett verifieringsmail till din e-post – klicka på länken i mejlet för att aktivera kontot. Därefter loggar du in och kan börja använda tjänsten.
        </Typography>

        {/* Steg 2: Tripploggar */}
        <Typography
          variant="h2"
          component="h2"
          sx={{
            fontSize: { xs: '1.25rem', md: '1.5rem' },
            fontWeight: 600,
            color: '#1A237E',
            mt: 5,
            mb: 1,
          }}
        >
          2. Tripploggar
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2, lineHeight: 1.7 }}>
          I en tripplogg kan du dokumentera en båttur med titel, år, avgångs- och ankomsttid, vindriktning och vindstyrka, sträcka, position och en fri beskrivning. Du kan också lägga till bilder. Allt sparas så att du lätt kan gå tillbaka och se vad som hände under resan.
        </Typography>

        {/* Steg 3: Serviceloggar */}
        <Typography
          variant="h2"
          component="h2"
          sx={{
            fontSize: { xs: '1.25rem', md: '1.5rem' },
            fontWeight: 600,
            color: '#1A237E',
            mt: 5,
            mb: 1,
          }}
        >
          3. Serviceloggar
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2, lineHeight: 1.7 }}>
          Serviceloggar är till för underhåll och reparationer. Du anger datum, båtens namn/modell, motortyp, vem som utfört arbetet och vilken typ av service det gäller. Det finns fält för motor, rigg och segel, elektronik och navigation, skrov och däck, roder och propeller, bränslesystem, batteri och el, reservdelar och rekommenderade åtgärder, samt kostnad och tid. Du kan lägga till kommentarer och bilder. På så sätt bygger du upp en tydlig historik över allt som gjorts på båten.
        </Typography>

        {/* Steg 4: Inbjudningar (Premium) */}
        <Typography
          variant="h2"
          component="h2"
          sx={{
            fontSize: { xs: '1.25rem', md: '1.5rem' },
            fontWeight: 600,
            color: '#1A237E',
            mt: 5,
            mb: 1,
          }}
        >
          4. Inbjudningar (Premium)
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2, lineHeight: 1.7 }}>
          Med Premium kan du bjuda in andra till din loggbok via e-post. Du väljer om de ska ha rollen Läsare eller Redaktör. Den inbjudna får en inbjudningskod som används när de skapar konto eller kopplar sig till din loggbok. Inbjudningar hanteras under menyn Inbjudningar i appen. Vill du veta mer om vad som ingår i Bas respektive Premium kan du läsa på{' '}
          <Link to="/pricing" style={{ color: '#1565C0', fontWeight: 500 }}>Priser</Link>.
        </Typography>

        {/* Avslutning */}
        <Typography variant="body1" sx={{ color: '#212121', mt: 5, mb: 3, lineHeight: 1.7 }}>
          Allt du lägger in sparas säkert och är privat – du bestämmer själv vem som har tillgång. När du är redo kan du komma igång genom att logga in eller skapa konto på startsidan.
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
          <Button
            component={Link}
            to="/?tab=login"
            variant="contained"
            sx={{
              backgroundColor: '#1565C0',
              color: '#fff',
              textTransform: 'none',
              '&:hover': { backgroundColor: '#0d47a1' },
            }}
          >
            Kom igång
          </Button>
          <Button
            component={Link}
            to="/?tab=signup"
            variant="outlined"
            sx={{
              borderColor: '#1565C0',
              color: '#1565C0',
              textTransform: 'none',
              '&:hover': { borderColor: '#0d47a1', backgroundColor: 'rgba(21, 101, 192, 0.04)' },
            }}
          >
            Skapa konto
          </Button>
          <Button
            component={Link}
            to="/pricing"
            variant="text"
            sx={{
              color: '#1565C0',
              textTransform: 'none',
              '&:hover': { backgroundColor: 'rgba(21, 101, 192, 0.04)' },
            }}
          >
            Priser
          </Button>
        </Box>
      </Container>
    </Box>
  );
}

export default HowItWorks;
